import React from 'react'

function SectionBreak() {
  return (
    <div className="pt-20 lg:pt-28" />
  )
}

export default SectionBreak